'use client';

import { useEffect, useRef } from 'react';

import { useGetCommonStore } from '@/store';

export const useLoyaltySSESubscription = () => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const subscribeLoyaltySse = useCommonStore.use.subscribeLoyaltySse();
  const unsubscribeLoyaltySse = useCommonStore.use.unsubscribeLoyaltySse();

  const isAuthenticatedRef = useRef(isAuthenticated);
  useEffect(() => {
    isAuthenticatedRef.current = isAuthenticated;
  });

  useEffect(() => {
    if (!isAuthenticated) {
      unsubscribeLoyaltySse();
      return;
    }

    subscribeLoyaltySse();

    return () => {
      // Skip unsubscribe if user is still authenticated — this is a remount
      // (e.g. Suspense boundary triggered by useSearchParams in StoreClient),
      // not a real logout. The next effect run will reuse the existing connection.
      if (!isAuthenticatedRef.current) {
        unsubscribeLoyaltySse();
      }
    };
  }, [isAuthenticated, subscribeLoyaltySse, unsubscribeLoyaltySse]);
};
